import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postDoesEmailExist = (email) => {
    return fetch(`${getApiUrl()}does_email_exist/${email}`, {
        method: "POST"
    })
}

export default postDoesEmailExist